const MAX_WIDTH = 400;
const MAX_HEIGHT = 400;
export const PREVIEW_MAX_RATIO = 3;
export const PREVIEW_MIN_RATIO = 1 / 3;

export const isExtremePreviewRatio = (width, height) => {
  if (!width || !height) return false;
  const ratio = width / height;
  return ratio > PREVIEW_MAX_RATIO || ratio < PREVIEW_MIN_RATIO;
};

/** Reserve space before imageSize/meta is known so anchor scroll does not jump on load. */
const DEFAULT_PLACEHOLDER = { width: MAX_WIDTH, height: MAX_WIDTH * 0.75 };

const getImageDimensions = meta => {
  const imageSize = meta?.imageSize;
  if (!imageSize || typeof imageSize !== 'string') return DEFAULT_PLACEHOLDER;

  const parts = imageSize.split('x');
  if (parts.length < 2) return DEFAULT_PLACEHOLDER;

  const width = +parts[0];
  const height = +parts[1];
  if (!width || !height) return DEFAULT_PLACEHOLDER;

  const aspectRatio = Math.max(Math.min(width / height, PREVIEW_MAX_RATIO), PREVIEW_MIN_RATIO);
  if (width > height) {
    return {
      width: MAX_WIDTH,
      height: MAX_WIDTH / aspectRatio,
    };
  }
  return {
    width: MAX_HEIGHT * aspectRatio,
    height: MAX_HEIGHT,
  };
};

export default getImageDimensions;
